import nb from './nb'
import Utils from '../Utils'

var nbMsg = {
  'agreements.title': 'Avtaler',
  'agreements.error.mandatory': "Du må godta å fortsette å bruke Deeper-tjenester",
  'agreements.error.blank': "Vennligst foreta et valg",
  'agreements.back': 'Tilbake',
  'agreements.agree': 'Godta',
  'agreements.decline': 'Avslå',
  'agreements.text.full': 'Fullstendig avtale'
}

Utils.addTerms(nbMsg, nb)

export default nbMsg



// WEBPACK FOOTER //
// ./src/lang/nbMsg.js